import { ArrowUpRight, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

import { MERCHANT } from '../../constants/merchant';
import { COMPETITION, QUIZ_BRAND } from '../../constants/competition';
import { BrandMark } from './BrandMark';

export function PublicFooter() {
  return (
    <footer className="site-footer bg-navy text-white">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 lg:px-10 lg:py-18">
        <div className="grid gap-12 border-b border-white/10 pb-12 lg:grid-cols-[1.3fr_0.7fr_0.7fr]">
          <div className="max-w-lg">
            <BrandMark inverse />
            <p className="mt-6 text-sm leading-7 text-slate-300">
              {QUIZ_BRAND.title} by {QUIZ_BRAND.name}, for school students in Classes 6–12. From the National Qualifier to the Grand Finale, celebrate knowledge on a national stage.
            </p>
            <p className="mt-4 text-sm leading-7 text-slate-300">National Knowledge Championship is a programme and brand operated by <a className="font-semibold text-white underline decoration-white/40 underline-offset-4" href={MERCHANT.website} target="_blank" rel="noreferrer">{MERCHANT.legalName}</a>. Registration payments are collected by {MERCHANT.legalName}.</p>
            <div className="mt-6 space-y-3 text-sm text-slate-300">
              <p className="flex items-start gap-3"><MapPin className="mt-0.5 size-4 shrink-0 text-gold" aria-hidden="true" /> {MERCHANT.address}</p>
              <p className="flex items-center gap-3"><Mail className="size-4 text-gold" aria-hidden="true" /> <a href={`mailto:${MERCHANT.supportEmail}`}>{MERCHANT.supportEmail}</a></p>
            </div>
          </div>
          <div>
            <p className="footer-heading">Explore</p>
            <div className="mt-4 grid gap-3 text-sm text-slate-300">
              <Link to="/competition">Competition</Link><Link to="/about-operator">About the operator</Link><Link to="/rules">Rules & eligibility</Link><Link to="/faq">FAQs</Link><Link to="/contact">Contact</Link><Link to="/feedback">Complaints & feedback</Link><Link to="/verify-certificate">Verify certificate</Link>
            </div>
          </div>
          <div>
            <p className="footer-heading">Policies</p>
            <div className="mt-4 grid gap-3 text-sm text-slate-300">
              <Link to="/privacy">Privacy policy</Link><Link to="/terms">Terms & conditions</Link><Link to="/refund-policy">Cancellation & refunds</Link><Link to="/fulfilment-policy">Service fulfilment</Link><Link to="/accessibility">Accessibility</Link>
              <Link className="inline-flex items-center gap-1 text-gold" to="/register">Registration <ArrowUpRight className="size-3.5" aria-hidden="true" /></Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 pt-7 text-xs text-slate-400 sm:flex-row sm:justify-between">
          <p>© {COMPETITION.year} {MERCHANT.legalName}. All rights reserved.</p>
          <p>{COMPETITION.shortName} · {QUIZ_BRAND.title} by {QUIZ_BRAND.name}</p>
        </div>
      </div>
    </footer>
  );
}
